import { State } from 'xstate';

import { ProductBuilderMachineContext } from '../types';

type ThrowError = (
  state: State<ProductBuilderMachineContext>,
  additionalMessage?: string,
) => void;

export const throwError: ThrowError = (state, additionalMessage) => {
  const { pathname, search } = window.location;
  const currentState = state.toStrings().join('.');
  throw new Error(
    `Error in: ${currentState}, Path: ${pathname}, Params: ${search}${
      additionalMessage ? `, Additional message: ${additionalMessage}` : ''
    }`,
  );
};
